import { render, staticRenderFns } from "./Prize2List.vue?vue&type=template&id=e1d4788e&scoped=true&"
import script from "./Prize2List.vue?vue&type=script&lang=js&"
export * from "./Prize2List.vue?vue&type=script&lang=js&"
import style0 from "./Prize2List.vue?vue&type=style&index=0&id=e1d4788e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1d4788e",
  null
  
)

export default component.exports